module.exports = __webpack_public_path__ + "static/deep-sea-blue--small-81144c253d47b9fa7b6232d1c71b20b6.jpg";